/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "driver-management",
	data() {
		return {
			vehicles: [],
			vehicleHeadings: [
				{
					text: "Make",
					field: "make"
				},
				{
					text: "Model",
					field: "model"
				},
				{
					text: "Year",
					field: "year"
				},
				{
					text: "Vehicle Registration",
					field: "vehicleRegistration"
				},
				{
					text: "Trailer Registration",
					field: "trailerRegistration"
				},
				{
					text: "Fleet Number",
					field: "fleetNumber"
				},
				{
					text: "Capacity (Litres)",
					field: "capacity"
				},
				{
					text: "Default Driver",
					field: "defaultDriver"
				},
				{
					text: "Default Driver ID",
					field: "defaultDriverId"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			drivers: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				viewVehicle: "viewVehicle"
			},
			vehicleAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditVehicleModal",
				heading: "Add Vehicle",
				vehicle:{
					vehicleId: null,
					vehicleMake: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					vehicleModel: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					vehicleYear: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					vehicleRegistration: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					driverId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					trailerRegistration: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					fleetNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					capacity: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					isActive: true,
					vehicleCompartmentProducts: [],
					vehicleCompartmentProductsToRemove: [],
					vehicleCompartmentError: null
				}
			},
			vehicleMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveVehicleModal",
				heading: "Mark Vehicle As Active/Inactive",
				isActive: null,
				vehicleId: null
			},
			newAddOrUpdateConcluded: false,
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getVehicles(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
			};
			systemService.getAllVehicles(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.vehicles = successResponse.data.result;
						for(let i = 0; i < this.vehicles.length; i++){
							this.vehicles[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnLogisticsVehicleEditVehicle"
								},
								{
									name: this.vehicles[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnLogisticsVehicleMarkAsActiveInactive"
								}
							];
						}
						this.vehicles = dataTableHelper.castFieldValues(this.vehicles);
						this.filterStateChanged = false;
						this.newAddOrUpdateConcluded = false;
						permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDrivers(){
			let request = {
				isActive: true
			};
			systemService.getAllDrivers(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.drivers = successResponse.data.result;
						this.drivers = $.map(this.drivers,
							function (obj) {
								obj.id = obj.id || obj.driverId;
								obj.text = obj.text || obj.firstName + " " + obj.lastName + " (" + obj.employeeNumber + ")";
								return obj;
							});
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getVehicles();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onAddVehicleClick(){
			this.vehicleAddEditFormModal.showModal = true;
		},
		onVehicleActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.vehicleAddEditFormModal.showModal = true;
					this.vehicleAddEditFormModal.heading = "Edit Vehicle - " + actionAndData.data.vehicleRegistration;
					this.vehicleAddEditFormModal.vehicle.vehicleId = actionAndData.data.vehicleId;
					this.vehicleAddEditFormModal.vehicle.vehicleMake.value = actionAndData.data.make;
					this.vehicleAddEditFormModal.vehicle.vehicleModel.value = actionAndData.data.model;
					this.vehicleAddEditFormModal.vehicle.vehicleYear.value = actionAndData.data.year;
					this.vehicleAddEditFormModal.vehicle.vehicleRegistration.value = actionAndData.data.vehicleRegistration;
					this.vehicleAddEditFormModal.vehicle.driverId.value = actionAndData.data.defaultDriverId;
					this.vehicleAddEditFormModal.vehicle.trailerRegistration.value = actionAndData.data.trailerRegistration;
					this.vehicleAddEditFormModal.vehicle.fleetNumber.value = actionAndData.data.fleetNumber;
					this.vehicleAddEditFormModal.vehicle.capacity.value = actionAndData.data.capacity;
					this.vehicleAddEditFormModal.vehicle.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.vehicleMarkAsActiveInactiveModal.showModal = true;
					this.vehicleMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.vehicleMarkAsActiveInactiveModal.heading = "Mark Vehicle As " + (this.vehicleMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.vehicleRegistration;
					this.vehicleMarkAsActiveInactiveModal.vehicleId = actionAndData.data.vehicleId;
					break;
			}
		},
		onMarkVehicleActiveInactiveSelected(isActive){
			this.vehicleMarkAsActiveInactiveModal.isActive = isActive;
			console.log("vehicleMarkAsActiveInactiveModal.isActive", this.vehicleMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActiveOrInactive){
			this.vehicleMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				vehicleId: this.vehicleMarkAsActiveInactiveModal.vehicleId,
				isActive: markAsActiveOrInactive
			};
			systemService.markVehicleAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.vehicleMarkAsActiveInactiveModal.showModal = false;
						this.vehicleMarkAsActiveInactiveModal.isActive = true;
						this.vehicleMarkAsActiveInactiveModal.vehicleId = null;
						this.getVehicles();
					}
					this.vehicleMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.vehicleMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditVehicleModalCloseClick(){
			this.vehicleAddEditFormModal.showModal = false;
			this.clearVehicleModel();
		},
		onDriverSelect(driver)
		{
			this.vehicleAddEditFormModal.vehicle.driverId.value = driver.id;
		},
		onCapacityChangedForComponents(vehicleCompartmentProducts){
			this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProducts = JSON.parse(JSON.stringify(vehicleCompartmentProducts));
		},
		onCompartmentRemoved(compartment){
			console.log("compartment", compartment);
			this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProducts = JSON.parse(JSON.stringify(compartment.vehicleCompartmentProducts));
			this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProductsToRemove.push(...compartment.compartmentsRemoved);
			console.log("vehicleCompartmentProductsToRemove", this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProductsToRemove);
		},
		onAddOrEditVehicleSaveClick(){
			this.vehicleAddEditFormModal.isSaving = true;
			for(var i = 0; i < this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProducts.length; i++) {
				for (var j = 0; j < this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProducts[i].compartmentProducts.length; j++) {
					if (this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProducts[i].compartmentProducts[j].capacity === null || this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProducts[i].compartmentProducts[j].capacity <= 0) {
						this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProducts[i].compartmentProducts[j].capacity = 0;
					}
				}
			}
			let request = {
				vehicleId: this.vehicleAddEditFormModal.vehicle.vehicleId,
				make: this.vehicleAddEditFormModal.vehicle.vehicleMake.value,
				model: this.vehicleAddEditFormModal.vehicle.vehicleModel.value,
				year: this.vehicleAddEditFormModal.vehicle.vehicleYear.value,
				vehicleRegistration: this.vehicleAddEditFormModal.vehicle.vehicleRegistration.value,
				defaultDriverId: this.vehicleAddEditFormModal.vehicle.driverId.value === null ? 0 : this.vehicleAddEditFormModal.vehicle.driverId.value,
				trailerRegistration: this.vehicleAddEditFormModal.vehicle.trailerRegistration.value,
				fleetNumber: this.vehicleAddEditFormModal.vehicle.fleetNumber.value,
				capacity: this.vehicleAddEditFormModal.vehicle.capacity.value === null ? 0 : this.vehicleAddEditFormModal.vehicle.capacity.value,
				isActive: this.vehicleAddEditFormModal.vehicle.isActive,
				vehicleCompartmentProducts: this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProducts,
				vehicleCompartmentProductsToRemove: this.vehicleAddEditFormModal.vehicle.vehicleCompartmentProductsToRemove
			};
			systemService.addOrUpdateVehicle(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					let validationError = false;
					if(isSuccess){
						if(successResponse.data.vehicleValidationResponse.valuesAreValid){
							this.getVehicles();
							this.vehicleAddEditFormModal.showModal = false;
							this.clearVehicleModel();
						}
						else{
							validationError = true;
							this.vehicleAddEditFormModal.vehicle.vehicleMake.hasError = successResponse.data.vehicleValidationResponse.makeValidationResponse.hasError;
							this.vehicleAddEditFormModal.vehicle.vehicleMake.errorMessage = successResponse.data.vehicleValidationResponse.makeValidationResponse.message;

							this.vehicleAddEditFormModal.vehicle.vehicleModel.hasError = successResponse.data.vehicleValidationResponse.modelValidationResponse.hasError;
							this.vehicleAddEditFormModal.vehicle.vehicleModel.errorMessage = successResponse.data.vehicleValidationResponse.modelValidationResponse.message;
						
							this.vehicleAddEditFormModal.vehicle.vehicleYear.hasError = successResponse.data.vehicleValidationResponse.yearValidationResponse.hasError;
							this.vehicleAddEditFormModal.vehicle.vehicleYear.errorMessage = successResponse.data.vehicleValidationResponse.yearValidationResponse.message;
							
							this.vehicleAddEditFormModal.vehicle.vehicleRegistration.hasError = successResponse.data.vehicleValidationResponse.vehicleRegistrationValidationResponse.hasError;
							this.vehicleAddEditFormModal.vehicle.vehicleRegistration.errorMessage = successResponse.data.vehicleValidationResponse.vehicleRegistrationValidationResponse.message;
							
							this.vehicleAddEditFormModal.vehicle.driverId.hasError = successResponse.data.vehicleValidationResponse.defaultDriverIdValidationResponse.hasError;
							this.vehicleAddEditFormModal.vehicle.driverId.errorMessage = successResponse.data.vehicleValidationResponse.defaultDriverIdValidationResponse.message;
							
							this.vehicleAddEditFormModal.vehicle.trailerRegistration.hasError = successResponse.data.vehicleValidationResponse.trailerRegistrationValidationResponse.hasError;
							this.vehicleAddEditFormModal.vehicle.trailerRegistration.errorMessage = successResponse.data.vehicleValidationResponse.trailerRegistrationValidationResponse.message;
							
							this.vehicleAddEditFormModal.vehicle.capacity.hasError = successResponse.data.vehicleValidationResponse.capacityValidationResponse.hasError;
							this.vehicleAddEditFormModal.vehicle.capacity.errorMessage = successResponse.data.vehicleValidationResponse.capacityValidationResponse.message;
							
							if(successResponse.data.vehicleCompartmentValidationResponse !== null && successResponse.data.vehicleCompartmentValidationResponse !== undefined) {
								this.vehicleAddEditFormModal.vehicle.vehicleCompartmentError = successResponse.data.vehicleCompartmentValidationResponse.message;
							}
						}
					}
					if(!validationError){
						this.vehicleAddEditFormModal.showModal = false;
					}
					this.vehicleAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.vehicleAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.vehicleAddEditFormModal.showModal = false;
				}
			);
		},
		clearVehicleModel(){
			this.vehicleAddEditFormModal.vehicle = {
				vehicleId: null,
				vehicleMake: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleModel: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleYear: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleRegistration: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				driverId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				trailerRegistration: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				fleetNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				capacity: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: true,
				vehicleCompartmentProducts: []
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Vehicle Management");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Logistics"
			};
			var vehicleManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Vehicle Management"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(vehicleManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getVehicles();
		this.getDrivers();
	}
};